/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Branches_Archive_Confirm_TitleInputs */

const en_branches_archive_confirm_title = /** @type {(inputs: Branches_Archive_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archive branch?`)
};

const pt_br2_branches_archive_confirm_title = /** @type {(inputs: Branches_Archive_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquivar filial?`)
};

/**
* | output |
* | --- |
* | "Archive branch?" |
*
* @param {Branches_Archive_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const branches_archive_confirm_title = /** @type {((inputs?: Branches_Archive_Confirm_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Branches_Archive_Confirm_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_branches_archive_confirm_title(inputs)
	return pt_br2_branches_archive_confirm_title(inputs)
});